import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { FuseNavigationItem } from '@fuse/components/navigation/navigation.types';
import { ItemFilter, ItemFolder, ItemLabel } from '../file-manager.types';
import { FileManagerService } from '../file-manager.service';
import { FileManagerComponent } from '../file-manager.component';
import { labelColorDefs } from '../file-manager.constants';
import { Subject, takeUntil } from 'rxjs';
import * as consts from 'app/shared/global-constants';
import { Router, RouterLink } from '@angular/router';
import { Util } from 'app/models/util';
import { LpmLabelPipe } from '@fuse/pipes/lpm-label.pipe';

@Component({
    selector     : 'file-manager-sidebar',
    templateUrl  : './file-manager-sidebar.component.html',
    styleUrls    : ['./file-manager-sidebar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone   : true,
    imports: [
        FuseVerticalNavigationComponent,
        MatIconModule,
        MatMenuModule,
        MatButtonModule,
        MatProgressBarModule,
        FileManagerComponent,
        RouterLink
    ],
})
export class FileManagerSidebarComponent implements OnInit, OnDestroy
{
    menuData: FuseNavigationItem[];
    menuData2: FuseNavigationItem[];
    labels: ItemLabel[];
    private _foldersMenuData: FuseNavigationItem[] = [];
    private _labelsMenuData: FuseNavigationItem[] = [];
    private _otherMenuData: FuseNavigationItem[] = [];
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    filters: ItemFilter[];
    storage={storageSize:0,storageThreshold:0}
    storagePercentage=0

    constructor(
        private _matDialog: MatDialog,
        private _fileManagerService: FileManagerService,
        public _fileManagerComponent: FileManagerComponent,
        private _fuseNavigationService: FuseNavigationService,
        private _router: Router,
        private util : Util,
        private labelPipe: LpmLabelPipe,
    )
    {

        // this.labels = consts.labels;
      
    }

    ngOnInit(): void 
    {       
        // this.setAccountStorage()
        // Folders
        this._generateFoldersMenuLinks();
        this._generateLabelsMenuLinks();
        this._generateOtherMenuLinks();
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
  
    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Generate menus for folders
     *
     * @private
     */
    private _generateFoldersMenuLinks(): void
    {
        // Reset the folders menu data
        this._foldersMenuData = [
            {
                title   : 'Menu',
                subtitle: null,
                type    : 'group',
                children: [
                    {
                        title: 'Home',
                        type : 'basic',
                        tooltip : 'Home',
                        link : '/apps/file-manager',
                        icon : 'heroicons_outline:home',
                    },
                    
                    {
                        title: 'Recent',
                        type : 'basic',
                        tooltip : 'Recently added data assets',
                        link : '/apps/file-manager/recent',
                        icon : 'heroicons_outline:clock',
                    },
                    {
                        title: 'Starred',
                        type : 'basic',
                        tooltip : 'Items marked important',
                        link : '/apps/file-manager/starred',
                        icon : 'heroicons_outline:star',
                    },
                    {
                        title: 'Shared',
                        type : 'basic',
                        tooltip : 'Assets currently being shared',
                        link : '/apps/file-manager/shared',
                        icon : 'heroicons_outline:users',
                    },
                    {
                        title: this.labelPipe.transform('Trash', 'trashLocationLabel'),
                        type : 'basic',
                        tooltip : 'Assets queued for deletion',
                        link : '/apps/file-manager/trash',
                        icon : 'heroicons_outline:trash',
                    },
                ],
            },
           
            {
                title   : 'Administration',
                type    : 'group',
                children: [
                    {
                        title   : 'General',
                        type    : 'collapsable',
                        icon    : 'heroicons_outline:cog-8-tooth',
                        children: [
                            {
                                title: 'Labels',
                                type : 'basic',
                                link :  '/apps/settings/labels',
                            },
                            {
                                title: 'Notifications',
                                type : 'basic',
                                link : '/apps/settings/notifications',
                            },
                            {
                                title: 'Integrations',
                                type : 'basic',
                                link : '/apps/settings/integrations',
                            },
                         
                        ],
                    },
                    {
                        title   : 'Account',
                        type    : 'collapsable',
                        icon    : 'heroicons_outline:user-circle',
                        children: [
                            {
                                title: 'Preferences',
                                type : 'basic',
                                link : '/apps/settings/preferences',
                            },
                            {
                                title: 'Plan & Billing',
                                type : 'basic',
                                link : '/apps/settings/payment',
                            },
                            {
                                title: 'Users',
                                type : 'basic',
                                link : '/apps/settings/users',
                            },
                            {
                                title: 'Security',
                                type : 'basic',
                                link : '/apps/settings/security',
                            },
                        ],
                    },
                     {
                                title : 'Copilot',
                                type : 'collapsable',
                                icon : 'feather:cpu',
                                children: [
                                    {
                                        title: 'Settings',
                                        type: 'basic',
                                        link: '/apps/settings/copilot',
                                    },

                                    {
                                        title: 'Assistants',
                                        type: 'basic',
                                        link: '/apps/settings/assistants',
                                    },

                                    {
                                        title: 'Agents',
                                        type: 'basic',
                                        link: '/apps/settings/agents',
                                    },

                                    {
                                        title: 'Data Structure',
                                        type: 'basic',
                                        link: '/apps/settings/data-structure',
                                    }

                                ]

                            },
                    /*
                    {
                        title   : 'Reporting',
                        type    : 'collapsable',
                        icon    : 'heroicons_outline:chart-bar',
                        children: [
                            {
                                title: 'Hub',
                                type : 'basic',
                                link : '/reporting/dashboard',
                            },
                        ],
                    },
                    */
                ],
            },
            {
                type: 'divider',
            },
        ];

        // Update the menu data
        this._updateMenuData();
    }

    /**
     * Generate menus for labels
     *
     * @private
     */
    private _generateLabelsMenuLinks(): void
    {
        // Reset the labels menu
        this._labelsMenuData = [];

        // Iterate through the labels
        // this.labels.forEach((label) =>
        // {
        //     // Generate menu item for the label
        //     this._labelsMenuData.push({
        //         id     : label.id,
        //         title  : label.name,
        //         type   : 'basic',
        //         icon   : 'heroicons_outline:tag',
        //         classes: {
        //             icon: labelColorDefs[label.colorCode].text,
        //         },
        //         link   : '/apps/file-manager/label/' + label.id,
        //     });
        // });

        // Update the menu data
        this._updateMenuData();
    }

    /**
     * Generate other menus
     *
     * @private
     */
    private _generateOtherMenuLinks(): void
    {
        
     if(this.util.getUserFromSession().role !='ADMIN')
     this._foldersMenuData.splice(1, 1);

     this._updateMenuData();
    }

    /**
     * Update the menu data
     *
     * @private
     */
    private _updateMenuData(): void
    {
       
        this.menuData = [
            ...this._foldersMenuData,
            /*
            {
                title   : 'STATUS',
                type    : 'group',
                children: [
                    ...this._labelsMenuData,
                ],
            },
            
            {
                type: 'spacer',
            },
            */
        ];
        // if(this.util.getUserFromSession().role !='ADMIN'){
        //     this.menuData.slice(1);
        // }
    }
    
    setAccountStorage(){
        const account=this.util.getAccountFromSession()
        this.storage.storageSize=account.storageSize
        this.storage.storageThreshold=account.storageThreshold
        this.storagePercentage=(this.storage.storageSize/this.storage.storageThreshold)*100
    }
}
